var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _g3, _path9, _g4, _path10, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 32,
    viewBox: "0 0 125 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4953 22.9056C86.7785 23.225 86.749 23.7133 86.4293 23.9962L86.2389 24.1647C85.9192 24.4476 85.4303 24.4181 85.1471 24.0987L80.5773 18.9459L79.3143 20.0341V23.5878C79.3143 24.0146 78.9682 24.3604 78.5409 24.3604H78.2869C77.8599 24.3604 77.5135 24.0146 77.5135 23.5878V8.07913C77.5135 7.65235 77.8599 7.30662 78.2869 7.30662H78.5409C78.9682 7.30662 79.3143 7.65235 79.3143 8.07913V17.6584L80.0672 17.0097L80.7396 16.415L80.7474 16.4239L85.3186 12.4858C85.6418 12.2074 86.1304 12.2433 86.4094 12.5665L86.5751 12.7587C86.8541 13.0815 86.8182 13.5695 86.4947 13.8482L81.9416 17.7706L86.4953 22.9056ZM52.7949 22.5606H50.537C49.3507 22.5606 48.386 21.5965 48.386 20.412V16.2368C48.386 15.0523 49.3507 14.0886 50.537 14.0886H56.0977V20.481C56.0977 22.3003 53.8597 22.5606 52.7949 22.5606ZM57.1251 7.30662H56.8714C56.4441 7.30662 56.0977 7.65235 56.0977 8.07913V12.2898H50.537C48.3579 12.2898 46.5851 14.0605 46.5851 16.2368V20.412C46.5851 22.5886 48.3579 24.3593 50.537 24.3593H52.7949C54.0545 24.3593 55.2065 23.899 56.0977 23.1409V23.5878C56.0977 24.0146 56.4441 24.3604 56.8714 24.3604H57.1251C57.5524 24.3604 57.8985 24.0146 57.8985 23.5878V19.2612V12.2898V8.07913C57.8985 7.65235 57.5524 7.30662 57.1251 7.30662ZM71.5622 20.412C71.5622 21.5965 70.5971 22.5606 69.4111 22.5606H66.0012C64.8149 22.5606 63.8501 21.5965 63.8501 20.412V16.2368C63.8501 15.0523 64.8149 14.0886 66.0012 14.0886H69.4111C70.5971 14.0886 71.5622 15.0523 71.5622 16.2368V20.412ZM69.4111 12.2898H66.0012C63.8221 12.2898 62.0493 14.0605 62.0493 16.2368V20.412C62.0493 22.5886 63.8221 24.3593 66.0012 24.3593H69.4111C71.5899 24.3593 73.363 22.5886 73.363 20.412V16.2368C73.363 14.0605 71.5899 12.2898 69.4111 12.2898ZM25.1693 20.412C25.1693 21.5965 24.2042 22.5606 23.0183 22.5606H19.6083C18.4221 22.5606 17.4573 21.5965 17.4573 20.412V16.2368C17.4573 15.0523 18.4221 14.0886 19.6083 14.0886H23.0183C24.2042 14.0886 25.1693 15.0523 25.1693 16.2368V20.412ZM23.0183 12.2898H19.6083C17.4292 12.2898 15.6565 14.0605 15.6565 16.2368V20.412C15.6565 22.5886 17.4292 24.3593 19.6083 24.3593H23.0183C25.1974 24.3593 26.9702 22.5886 26.9702 20.412V16.2368C26.9702 14.0605 25.1974 12.2898 23.0183 12.2898ZM11.506 16.2232V23.5878C11.506 24.0146 11.1595 24.3604 10.7323 24.3604H10.4786C10.0513 24.3604 9.70517 24.0146 9.70517 23.5878V16.2232C9.70517 15.044 8.74827 14.0886 7.56781 14.0886H5.81422C3.70185 14.0886 2.23277 14.9432 2.23277 15.7738V23.5878C2.23277 24.0146 1.8863 24.3604 1.45903 24.3604H1.20534C0.778075 24.3604 0.431946 24.0146 0.431946 23.5878V13.0698C0.431946 12.6434 0.778075 12.2973 1.20534 12.2973H1.45903C1.8863 12.2973 2.23277 12.6434 2.23277 13.0698V13.8119C2.45325 13.5859 2.7357 13.3438 3.01815 13.1177C3.61215 12.6431 4.82171 12.2898 5.81422 12.2898H7.56781C9.74284 12.2898 11.506 14.0506 11.506 16.2232ZM37.3304 22.5606H35.0725C33.8866 22.5606 32.9215 21.5965 32.9215 20.412V16.2368C32.9215 15.0523 33.8866 14.0886 35.0725 14.0886H40.6335V20.481C40.6335 22.3003 38.3951 22.5606 37.3304 22.5606ZM41.6609 7.30662H41.4069C40.98 7.30662 40.6335 7.65235 40.6335 8.07913V12.2898H35.0725C32.8937 12.2898 31.1206 14.0605 31.1206 16.2368V20.412C31.1206 22.5886 32.8937 24.3593 35.0725 24.3593H37.3304C38.5899 24.3593 39.7423 23.899 40.6335 23.1409V23.5878C40.6335 24.0146 40.98 24.3604 41.4069 24.3604H41.6609C42.0882 24.3604 42.4343 24.0146 42.4343 23.5878V19.2612V12.2898V8.07913C42.4343 7.65235 42.0882 7.30662 41.6609 7.30662Z",
    fill: "#20003F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23_1666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 11,
    width: 9,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.875 11.7639C105.677 11.7639 104.718 12.7214 104.718 13.9183V18.0904C104.718 19.2873 105.677 20.2448 106.875 20.2448H110.264C111.463 20.2448 112.421 19.2873 112.421 18.0904V13.9183C112.421 12.7214 111.463 11.7639 110.264 11.7639H106.875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-305.571 281.51H351.765V-87.8178H-305.571V281.51Z",
    fill: "url(#paint0_radial_23_1666)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.563 5.68821L112.863 6.54724L112.006 2.24935L108.563 5.68821Z",
    fill: "#3B237B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.566 26.3254L104.266 25.4664L105.123 29.7643L108.566 26.3254Z",
    fill: "#3B237B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7894 12.5672L99.0936 11.7075L98.2329 16.0067L94.7894 12.5672Z",
    fill: "#3B237B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.34 19.4461L118.036 20.3058L118.896 16.0065L122.34 19.4461Z",
    fill: "#3B237B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_23_1666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 5,
    width: 17,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.351 19.4582L123.721 18.0561C124.85 16.9276 124.85 15.081 123.721 13.9525L118.585 8.82289C117.661 7.89957 116.497 7.28402 115.23 7.01044L108.554 5.67676L122.351 19.4582Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_23_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-490.383 101.568L31.5042 609.695L536.583 92.1241L14.6953 -416.002L-490.383 101.568Z",
    fill: "url(#paint1_linear_23_1666)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_23_1666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 0,
    width: 19,
    height: 13
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.497 0.854927L94.7884 12.5503L101.464 11.2508C102.731 10.9773 103.895 10.3617 104.785 9.43839L112.009 2.25701L110.606 0.854927C110.058 0.307774 109.305 0 108.551 0C107.832 0 107.079 0.307774 106.497 0.854927Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_23_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6517 609.783L536.632 94.8496L19.5456 -416.091L-490.434 98.8422L26.6517 609.783Z",
    fill: "url(#paint2_linear_23_1666)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_23_1666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 12,
    width: 17,
    height: 15
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3818 13.9524C92.252 15.0809 92.252 16.9275 93.3818 18.056L98.5515 23.2198C99.4759 24.1089 100.64 24.7244 101.907 24.998L108.548 26.3317L94.7855 12.5503L93.3818 13.9524Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_23_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.636 95.8967L21.4053 -416.105L-490.446 97.7956L24.7849 609.798L536.636 95.8967Z",
    fill: "url(#paint3_linear_23_1666)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_23_1666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 19,
    width: 18,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.674 20.7918C114.407 21.0312 113.243 21.6467 112.319 22.5701L105.129 29.7514L106.533 31.1535C107.663 32.282 109.477 32.282 110.607 31.1535L122.35 19.4581L115.674 20.7918Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_23_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8676 -416.068L-490.422 99.7851L28.3284 609.761L536.618 93.9075L17.8676 -416.068Z",
    fill: "url(#paint4_linear_23_1666)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_23_1666",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.472 15.897) scale(7.15303 7.14484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159524,
    stopColor: "#EB1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313095,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446429,
    stopColor: "#D01253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57619,
    stopColor: "#B70F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70119,
    stopColor: "#960C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811905,
    stopColor: "#710848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919048,
    stopColor: "#460443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21003F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_1666",
    x1: 105.517,
    y1: 1.66476,
    x2: 122.823,
    y2: 18.5528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20003F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136905,
    stopColor: "#530545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27381,
    stopColor: "#7F0A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404762,
    stopColor: "#A20D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527381,
    stopColor: "#BD1051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64881,
    stopColor: "#D21253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770238,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889286,
    stopColor: "#EA1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23_1666",
    x1: 93.0995,
    y1: 16.687,
    x2: 109.181,
    y2: 0.412143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20003F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136905,
    stopColor: "#530545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27381,
    stopColor: "#7F0A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404762,
    stopColor: "#A20D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527381,
    stopColor: "#BD1051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64881,
    stopColor: "#D21253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770238,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889286,
    stopColor: "#EA1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23_1666",
    x1: 111.292,
    y1: 30.2593,
    x2: 94.2485,
    y2: 13.2841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20003F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136905,
    stopColor: "#530545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27381,
    stopColor: "#7F0A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404762,
    stopColor: "#A20D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527381,
    stopColor: "#BD1051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64881,
    stopColor: "#D21253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770238,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889286,
    stopColor: "#EA1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23_1666",
    x1: 124.447,
    y1: 14.9892,
    x2: 108.104,
    y2: 31.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20003F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136905,
    stopColor: "#530545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27381,
    stopColor: "#7F0A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404762,
    stopColor: "#A20D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527381,
    stopColor: "#BD1051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64881,
    stopColor: "#D21253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770238,
    stopColor: "#E11455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889286,
    stopColor: "#EA1556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1556"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSecondary);
export default __webpack_public_path__ + "static/media/logo-secondary.35f82a9aae939142481d76f66834b2ae.svg";
export { ForwardRef as ReactComponent };